import React from "react";
import AllJobsTab from "../../tabs/AllJobsTab";
import UploadDialog from "../../section/JobSection/UploadDialog";
import WelcomeDialog from "../../card/dashboardCard/WelcomeDialog";
import { useParams } from "react-router-dom";
import AllJobsForSignUp from "./AllJobsForSignUp";

function AllJobs() {
  const params = useParams();
  return (
    // <Layout>
    <div className="w-full">
      {" "}
      {params?.id < 4 ? <AllJobsTab /> : <AllJobsForSignUp />}
    </div>
    // </Layout>
  );
}

export default AllJobs;
